import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import frCommon from "./locales/fr/common.json";
import enCommon from "./locales/en/common.json";

export const defaultNS = "common";
export const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: "fr",
  fallbackLng: "fr",
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
